import React from "react";

export default function AnugyaDemoSection() {

  return (
    <div className="p-4 bg-slate-900 rounded-2xl text-white space-y-4">

      {/* HEADER */}
      <div>
        <h2 className="text-xl font-bold flex items-center gap-2">
          <i className="fa-solid fa-video text-red-400"></i>
          See Anugya in Action
        </h2>

        <p className="text-sm text-slate-400 mt-1">
          Understand programmable consent in under 60 seconds
        </p>
      </div>

      {/* VIDEO */}
      <div className="rounded-xl overflow-hidden border border-slate-700">
        <iframe
          className="w-full aspect-video"
          src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
          title="Anugya Demo"
          allowFullScreen
        />
      </div>

      {/* VALUE POINTS */}
      <div className="grid grid-cols-1 gap-2 text-sm">

        <div className="bg-slate-800 p-3 rounded-xl">
          ⚡ Real-time consent execution engine
        </div>

        <div className="bg-slate-800 p-3 rounded-xl">
          🔐 End-to-end data governance flow
        </div>

        <div className="bg-slate-800 p-3 rounded-xl">
          📊 Full audit + traceability system
        </div>

      </div>

      {/* PRIMARY CTA */}
      <a
        href="https://www.youtube.com/@think5whys"
        target="_blank"
        className="block text-center bg-red-600 py-3 rounded-xl font-semibold"
      >
        ▶ Watch Full Channel
      </a>

    </div>
  );
}